<template>
  <div id="app" class="app-plans">
    <header id="header" v-if="$route.name !== 'cb-meet' && $route.name !== 'login'">
      <img alt="Logo" class="" :src="host" id="logo-header" />
      <b-dropdown
        v-if="isLoggedIn"
        right
        no-caret
        variant="link"
        toggle-class="header-menu-btn"
        menu-class="header-menu-dropdown"
      >
        <template #button-content>
          <b-icon icon="three-dots-vertical" font-scale="1.25" aria-label="Menu" />
        </template>
        <b-dropdown-item @click="goToPanel" class="header-menu-item">
          <b-icon-house class="mr-2" />
          Meu painel
        </b-dropdown-item>
        <b-dropdown-divider />
        <b-dropdown-item @click="doLogout" class="header-menu-item header-menu-item--logout">
          <b-icon-box-arrow-right class="mr-2" />
          Sair
        </b-dropdown-item>
      </b-dropdown>
    </header>

    <main
      class="plans-main"
      :class="{
        'plans-main--no-padding': isPlansMainNoPadding,
        'plans-main--meet': isMeetRoute,
      }"
    >
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </main>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ValeuSaudeLogo from '@/assets/images/tmed-plans/logo.png';

export default {
  name: 'app-layout-plans',
  data() {
    return {
      host: ValeuSaudeLogo,
    };
  },
  mounted() {
    if (this.isBrokers) {
      document.getElementById('logo-header').style.height = '42px';
      document.getElementById('header').style.padding = '0.875rem 1rem';
    } else if (this.isTemSaude) {
      document.getElementById('logo-header').style.height = '45px';
      document.getElementById('header').style.padding = '1.05rem 1rem';
    }
  },
  computed: {
    ...mapGetters({
      isBrokers: 'main/isBrokers',
      isTemSaude: 'main/isSubdomainTemSaude',
      getUserDetails: 'plans-auth/getUserDetails',
    }),
    isLoggedIn() {
      return !!this.getUserDetails?.email || !!localStorage.getItem('token');
    },
    isPlansMainNoPadding() {
      return this.$route.name === 'login' || this.isMeetRoute;
    },
    isMeetRoute() {
      return this.$route.name === 'cb-meet';
    },
  },
  methods: {
    ...mapActions({
      doLogout: 'plans-auth/doLogout',
    }),
    goToPanel() {
      this.$router.push({ name: 'backoffice-home' });
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/variables';

.app-plans {
  display: flex;
  min-height: 100vh;
  flex-direction: column;

  #header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .header-menu-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      padding: 0;
      border: none;
      background: transparent;
      color: var(--main-color);
      border-radius: 8px;
      cursor: pointer;
      transition: background-color 0.2s, color 0.2s;
      text-decoration: none;
    }

    .header-menu-btn:hover {
      background: rgba(0, 0, 0, 0.06);
    }

    .header-menu-dropdown {
      border-radius: 8px;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
      padding: 0.25rem 0;
    }

    .header-menu-item {
      display: flex;
      align-items: center;
      color: var(--txt);
      padding: 0.5rem 1rem;

      &:hover {
        color: var(--main-color);
        background-color: var(--btn-hour-bg);
      }

      &--logout:hover {
        color: var(--ipt-alert);
        background-color: rgba(233, 65, 98, 0.08);
      }

      .dropdown-item {
        background-color: transparent !important;
      }
    }
  }

  .plans-main {
    display: flex;
    flex-direction: column;
    flex: 1;
    padding-top: 80px;
    min-height: calc(100vh - 80px);

    @media screen and (max-width: 1200px) {
      padding-top: 60px;
      min-height: calc(100vh - 60px);
    }

    &.plans-main--no-padding {
      padding: 0;
      min-height: 100vh;
    }

    &.plans-main--meet {
      height: 100vh;
      height: 100dvh;
      min-height: 0;
      overflow: hidden;
    }

    /* Reset the global margin-top that #schedule applies for non-plans views */
    #schedule {
      margin-top: 0 !important;
      flex: 1;
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
